import { BASE_API_URL } from "./consts";

export interface UploadResult {
  key: string;
  url: string;
  filename: string;
  mimetype: string;
  size: number;
}

export async function uploadFileToR2(
  file: File,
  prefix: string = "uploads",
  clientId: string = "shared"
): Promise<UploadResult> {
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${BASE_API_URL}/${clientId}/upload?prefix=${prefix}`, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as any).message || "Upload failed");
  }

  return res.json();
}
